import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useCustomer} from '../hooks/useCustomer';
import {Customer} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useCustomer();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                email: '',
                phone: '',
            } as Customer}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
